import { useMemo } from "react";
import type { ModelDefinition } from "@/shared/types";
import { composeAvailableModels } from "@/components/chat-v2/shared/available-models";

/**
 * Models the current user can pick on any model-picker surface (eval suite
 * and judge editors, the client builder's Agent tab, the Playground): the
 * full SUPPORTED_MODELS catalog — the server holds the provider keys, so
 * nothing is gated on a browser-side key. Same `composeAvailableModels`
 * pipeline everywhere.
 */
export function useAvailableModels(): { availableModels: ModelDefinition[] } {
  const availableModels = useMemo(() => composeAvailableModels(), []);
  return { availableModels };
}
